<template>
    <div class="search">
        <div class="row">
            <div class="col-10">
                <autocomplete
                    :search="search"
                    placeholder="Kundensuche"
                    aria-label="Kundensuche"
                    :get-result-value="getResultValue"
                    @submit="handleSubmit"
                    ref="autocomplete"
                    @blur="handleBlur"
                    @focus="handleFocus"
                    autofocus
                    :debounce-time="500"
                ></autocomplete>
            </div>
            <div class="col-1 d-flex align-items-center">
                <b-icon icon="x-circle" scale="2"
                        style="color: #ec665a !important;"
                        class="cursor-pointer"
                        variant="danger"
                        @click="clearSearchInput"></b-icon>
            </div>
            <div class="col-1 d-flex align-items-center">
                <b-icon icon="keyboard"
                        scale="2"
                        class="cursor-pointer"
                        style="color: #ec665a !important;"
                        variant="success"
                        @click="showKeyboard = !showKeyboard"></b-icon>
            </div>
        </div>
        <keyboard-component
            v-if="showKeyboard"
            @keyPress="handleKeyPress"/>
    </div>
</template>

<script>
import {NotificationPositionEnum}                             from "../../constants/enums";
import {searchConsumerByQrCodeRequest, searchConsumerRequest} from "@/api/consumers";
import {store}                                                from '@/store';
import KeyboardComponent                                      from '@/components/keyboard/KeyboardComponent.vue';

export default {
    name:       "FooveAutocomplete",
    components: {KeyboardComponent},
    data() {
        return {
            showKeyboard: false,
            enableSearch: false,
        }
    },
    mounted() {
        if (this.$refs.autocomplete && this.$refs.autocomplete.$refs.input) {
            this.$refs.autocomplete.$refs.input.focus();
        }
    },
    methods: {
        search(input) {
            if (this.enableSearch) {
                this.enableSearch = false;
                return [];
            }

            const params = {
                term: input,
            };

            return new Promise(resolve => {
                if (input.length < 3) {
                    return resolve([])
                }

                if (input.length === 64) {
                    searchConsumerByQrCodeRequest(params)
                        .then(response => response.data)
                        .then(data => {
                            if (data.consumer_id) {
                                this.handleSubmit(data)
                            } else {
                                this.handleSubmit(null)
                            }
                        })
                        .catch(() => {
                            this.$refs.autocomplete.value = '';
                            store.dispatch('setNotificationSettings', {
                                position: NotificationPositionEnum.CENTER,
                                heading:  'QR-Code ungültig!',
                            });
                        })
                } else {
                    searchConsumerRequest(params)
                        .then(response => response.data)
                        .then(data => {
                            if (data.length) {
                                resolve(data)
                            } else {
                                resolve([])
                            }
                        })
                }
            })
        },
        getResultValue(result) {
            return `${result.firstname} ${result.lastname} ${result.locationGroup}`;
        },
        handleFocus() {
            this.enableSearch = false;
        },
        handleBlur() {
            this.enableSearch = true;
            if (this.$refs.autocomplete) {
                setTimeout(() => {
                    if (!document.querySelector('#order-preview-modal')) {
                        this.$refs.autocomplete.$refs.input.focus({preventScroll: true})
                        document.querySelector('.autocomplete-input').focus();
                    }
                }, 100);
            }
        },
        handleSubmit(result) {
            this.$emit('submit', result)
        },
        clearSearchInput() {
            if (this.$refs.autocomplete) {
                this.$refs.autocomplete.value = '';
            }
        },
        handleKeyPress(key) {
            this.enableSearch = false;
            const _self       = this;
            _self.value       = this.$refs.autocomplete.value;
            if (key === 'backspace') {
                _self.value = _self.value.slice(0, -1);
            } else {
                _self.value += key;
            }
            this.$refs.autocomplete.value = _self.value;
            this.$refs.autocomplete.core.updateResults(_self.value);
        }
    }
}
</script>

<style scoped lang="scss">
.search {
    width: 100%;
}

> > > .search .autocomplete-input {
    border-radius: 6px;
}

> > > .autocomplete[data-loading=true]:after {
    content: none !important;
}

.search-col {
    padding-right: 18px;
    border-right: 1px solid #D9D9D9;
}
</style>
